import React from 'react';
import PropTypes from 'prop-types';
import SimplePanel from '@/shared/components/SimplePanel';
import { injectIntl, FormattedMessage } from 'react-intl';
import messages from '../jobMessages';
import utils from '@/shared/utils/adminpulse';
import FormattedListValue, { listItemMsg } from '@/shared/components/FormattedListValue';

const JobDetailRelationFieldUpdate = ({ job, intl }) => {
  // Some json parameters might still be stored without camelcase in the db, so convert it to camelcase just in case
  const parameters = utils.toCamel(job.parameters);
  const fieldId = parameters.definition.id;
  return (
    <SimplePanel title={<FormattedListValue list="jobType" id={job.jobType} />}>
      <div className="info-block container-fluid radius4B">
        <div className="row">
          <div className="col-lg-6">
            <div className="row">
              <div className="col-md-5 col-sm-6">
                <label>
                  <b>
                    <FormattedMessage {...messages.Field} />
                  </b>
                </label>
              </div>
              <div className="col-md-7 col-sm-6">
                <span>{intl.formatMessage(listItemMsg('field', fieldId))}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </SimplePanel>
  );
};

JobDetailRelationFieldUpdate.propTypes = {
  job: PropTypes.shape({}).isRequired,
};

export default injectIntl(JobDetailRelationFieldUpdate);
